import React from "react";

const TextFieldComponent = (props) => {
	const {
		ref,
		disabled,
		name,
		type,
		className,
		values,
		handleBlur,
		onChange,
		handleChange,
		onChangeCallbackAction,
		errors,
		touched,
		errorStyleInput,
		placeholder,
		onKeyPress,
		maxLength,
	} = props;

	return (
		<input
			ref={ref}
			readOnly={disabled}
			id={name}
			name={name}
			type={type}
			autoComplete="off"
			className={`form-control ${className && className}`}
			value={values[name]}
			onBlur={handleBlur}
			onChange={(e) => {
				onChange ? onChange(e) : handleChange(e);
				if (onChangeCallbackAction) {
					onChangeCallbackAction(e);
				}
			}}
			style={errors[`${name}`] && touched[`${name}`] && errorStyleInput}
			placeholder={placeholder}
			onKeyPress={onKeyPress}
			maxLength={maxLength}
		/>
	);
};

export default TextFieldComponent;
